import { atom } from 'jotai'
import type { VisibleAssets } from '@app/components/Molecules/MapView/RiskMapView/RiskMapView.utilities'
import type { MapLayer } from '@app/types/layerTypes'

export const riskLayersAtom = atom<MapLayer[]>([])

export type FilterValuesType = Record<string, Record<string, string[] | null>> | null

export type FilterKeyValuesCache = Record<string, Record<string, string[]>> | null

export const visibleAssetsAtom = atom<VisibleAssets>({})

export const filterKeyValuesAtom = atom<FilterValuesType>(null)

export const filterKeyValuesCacheAtom = atom<FilterKeyValuesCache>(null)

export const layerLoadingAtom = atom(false)

export const applyVulnerabilityDataAtom = atom(true)
